module.exports = __webpack_public_path__ + "media/images/pic05-a2e65b8e38061da3d7e8410b9f436f7c.jpg";